import React, { useState } from "react";
import Header from "../components/print/Header";
import Price from "../components/print/Price";
import TotalCheck from "../components/print/TotalCheck";
import MOCK_DATA from "../data/print/mockData";
import OrderList from "../components/print/OrderList";

const Print = () => {
  const [data, setData] = useState(MOCK_DATA);

  return (
    <>
      <div className=" md:w-[40%] lg:w-[55%] mx-auto align-middle items-center text-center justify-center content-center flex flex-col">
        <Header data={data}/>
        <Price data={data}/>
        {/* 품목 */}
        <OrderList data={data} setData={setData}/>
        <TotalCheck data={data.orderData}/>
      </div>
      <div className="border-dashed mx-auto my-[20px] border-black md:w-[40%] lg:w-[55%] content-center justify-center items-center border"></div>
      <div className="md:w-[40%] lg:w-[55%] mx-auto align-middle items-center text-center justify-center content-center flex flex-col">
        <Header data={data}/>
        <Price data={data}/>
        {/* 품목 */}
        <OrderList data={MOCK_DATA}/>
        <TotalCheck data={MOCK_DATA.orderData}/>
      </div>
    </>
    
  )
}



export default Print